// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { setPathValidationsMessagesInDrawer } from 'redux/modules/pathValidationsDrawer'
import { postPathWarnings } from 'helpers/api'
import { parseValidationMessages } from 'redux/helpers'
import { UNCAUGHT_ERROR } from 'errors'

// NOTE - this throws to the caller which has its own try/catch

const handlePathWarningsCheck = pathId => async (dispatch, getState) => {
  const {
    entities,
    message,
  } = await postPathWarnings([pathId])

  // if we got entities here, that means we got warnings.
  // parse them warnings and put em in the drawer.
  if (entities.length) {
    const parsedValidationMessages = parseValidationMessages(entities)

    const validation = parsedValidationMessages[pathId]

    const newPathValidations = {
      [pathId]: {
        errors: [],
        heading: validation.heading,
        warnings: validation.messages,
      },
    }

    dispatch(setPathValidationsMessagesInDrawer(
      message || UNCAUGHT_ERROR,
      newPathValidations
    ))
  } else {
    // TODO - should this actually just call removeAllPathValidationsFromDrawer?
    dispatch(setPathValidationsMessagesInDrawer(
      null,
      {},
      [pathId]
    ))
  }
}

export default handlePathWarningsCheck
